module.exports = __webpack_public_path__ + "static/media/caseiq.c7ebea22.svg";